"use strict";


const baseTemplate = document.createElement("template");
baseTemplate.innerHTML = require("./template");

// // load font via webpack asset/resource
// require("src/tokens/index.css");


// see https://inclusive-components.design/tooltips-toggletips/
// see https://zoebijl.github.io/apg-tooltip/

class Tooltip extends HTMLElement {
    constructor(template) {
        super(template);

        this.root = this.attachShadow({ mode: "open" });

        const content = template ? template.content.cloneNode(true) : baseTemplate.content.cloneNode(true);
        this.root.appendChild(content);
        this.tooltipContent = this.root.querySelector(".swiftref-tooltip");
        this.clearHtml = function () {
            this.innerHTML = ""
        }.bind(this);

    }



    connectedCallback() {
        if (this.innerHTML) {

            const icon = document.createElement("swiftref-icon");
            icon.setAttribute("kind", this.getAttribute("kind"));
            const size = this.getAttribute("size");
            icon.setAttribute("size", size);

            this.tooltipContent.innerHTML = this.innerHTML;
            this.tooltipContent.style.left = "-9px";
            this.root.appendChild(icon);

            this.tooltipContent.style.width = "auto";

            icon.addEventListener("mouseenter", function () {
                this.tooltipContent.style.width = "";

                this.tooltipContent.classList.add("active");
                this.tooltipContent.style.bottom = "unset";
                this.tooltipContent.style.top = "unset";
                delete this.tooltipContent.style.top;
                delete this.tooltipContent.style.bottom;
                this.tooltipContent.classList.remove("bottom");
                const position = this.getAttribute("position") || "";

                const tooltipRect = this.tooltipContent.getBoundingClientRect();
                if (position.indexOf("left") !== -1 || ((tooltipRect.left + tooltipRect.width) > (window.innerWidth - tooltipRect.width - 25) && window.innerWidth > 800)) {// > 800 means is not a mobile phone
                    const offsetWidth = tooltipRect.width - 30;
                    this.tooltipContent.style.left = "-" + offsetWidth+"px";
                    this.tooltipContent.style.setProperty('--arrow-offset', (offsetWidth + 10) +"px")
                } else {
                    this.tooltipContent.style.left = "-9px";
                    this.tooltipContent.style.setProperty('--arrow-offset', 20+"px");
                }

                if (position.indexOf("bottom") !== -1) {
                    // if there is no space above the tooltip, move it down
                    // this.tooltipContent.style.bottom = "unset";
                    this.tooltipContent.style.top = "26px";
                    this.tooltipContent.classList.add("bottom");
                }
                const iconRect = icon.getBoundingClientRect();
                // there is space above the tooltip
                if (tooltipRect.height < tooltipRect.top - 10 && position.indexOf("bottom") === -1) {
                    this.tooltipContent.style.bottom = (iconRect.height + 20) + "px";
                }

            }.bind(this));

            icon.addEventListener("mouseleave", function () {
                this.tooltipContent.classList.remove("active");
                this.tooltipContent.style.left = "-9px";
                this.tooltipContent.style.setProperty('--arrow-offset', 20+"px");
                this.tooltipContent.style.width = "auto";
            }.bind(this));

            icon.addEventListener("touchend", function () {
                this.tooltipContent.classList.toggle("active");
            }.bind(this));

            // setTimeout(function () {
            //     this.innerHTML = "";
            // }.bind(this), 1000)
            // this.removeChild(this.root.querySelector("swiftref-tooltip"));
        }
    }

}

window.customElements.define("swiftref-tooltip", Tooltip);

module.exports = Tooltip;
